var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBookReaderSolid = function SvgBookReaderSolid(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7497 5.74993C15.7497 3.67887 14.0709 2 11.9998 2C9.92875 2 8.24988 3.67887 8.24988 5.74993C8.24988 7.82098 9.92875 9.49985 11.9998 9.49985C14.0709 9.49985 15.7497 7.82098 15.7497 5.74993ZM11.1244 11.4178C8.8069 9.99906 5.05307 9.60923 3.16404 9.50181C2.52929 9.46587 2 9.94945 2 10.56V19.2629C2 19.8227 2.45273 20.2895 3.03475 20.3196C4.74018 20.409 8.1905 20.7367 10.5752 21.9379C10.9412 22.1223 11.3752 21.8711 11.3752 21.4742V11.8654C11.3748 11.683 11.2846 11.5158 11.1244 11.4178ZM20.8356 9.50181C18.9469 9.60884 15.1927 9.99906 12.8756 11.4178C12.7154 11.5158 12.6252 11.6897 12.6252 11.8721V21.4731C12.6252 21.8711 13.0603 22.1227 13.4275 21.9379C15.8118 20.7379 19.2602 20.4102 20.9653 20.3207C21.5473 20.2903 22 19.8235 22 19.2637V10.56C21.9996 9.94945 21.4703 9.46587 20.8356 9.50181Z",
    fill: "#E4E7EC"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBookReaderSolid, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/book_reader_solid.a1955c47.svg";
export { ForwardRef as ReactComponent };